import { render } from "./AddLinkerWords.vue?vue&type=template&id=8d97600c&ts=true"
import script from "./AddLinkerWords.vue?vue&type=script&lang=ts"
export * from "./AddLinkerWords.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__